import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tutorial-start" }
const _hoisted_2 = { class: "tutorial-start__item" }
const _hoisted_3 = { class: "tutorial-start__btn-box" }
const _hoisted_4 = { class: "tutorial-start__item" }
const _hoisted_5 = { class: "tutorial-start__btn-box" }
const _hoisted_6 = {
  key: 0,
  class: "tutorial-question"
}
const _hoisted_7 = { class: "tutorial-start__item tutorial-start__question" }
const _hoisted_8 = { class: "tutorial-start__btn-box" }

import { computed } from 'vue'
import { BookTutorial } from '@/models/doc.tutorial'


export default /*@__PURE__*/_defineComponent({
  __name: 'Tutorial',
  props: {
    bookTutorial: {}
  },
  setup(__props: any) {

const props = __props

const showTutorialQuestion = computed(() => {
  return props.bookTutorial.step === 8 || props.bookTutorial.isVisible()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "tutorial-start__title" }, "Welcome!", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "tutorial-start__text" }, " Let’s go on a quick tour of a Shortform book guide. ", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            class: "tutorial-start__btn tutorial-start__btn--no-arr tutorial-next btns",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.bookTutorial.incrementStep()))
          }, "Start")
        ])
      ], 512), [
        [_vShow, __props.bookTutorial.step === 1]
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "tutorial-start__title" }, "1-Page Summary", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "tutorial-start__text" }, " Every guide starts with a 1-Page Summary. This is a 5-10 minute overview of the book’s key points. ", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                class: "tutorial-start__btn tutorial-next btns",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.bookTutorial.incrementStep()))
              }, [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Next", -1),
                _createElementVNode("span", { class: "tutorial-start__btn-arr iconfont inext" }, null, -1)
              ]))])
            ])
          ], 512), [
            [_vShow, __props.bookTutorial.step === 2]
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showTutorialQuestion.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _withDirectives(_createElementVNode("div", _hoisted_7, [
                _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "tutorial-start__title" }, "Finished!", -1)),
                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "tutorial-start__text" }, " If you ever need to see this tour again, click here. ", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("a", {
                    class: "tutorial-start__btn tutorial-start__btn--no-arr tutorial-close btns",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (__props.bookTutorial.resetStep()))
                  }, "Close")
                ])
              ], 512), [
                [_vShow, __props.bookTutorial.step === 8]
              ]),
              _withDirectives(_createElementVNode("a", {
                class: "tutorial-question__btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (__props.bookTutorial.start()))
              }, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("span", { class: "tutorial-question__icon iconfont iquestion" }, null, -1),
                _createElementVNode("span", { class: "tutorial-question__tips" }, "Guided Tour", -1)
              ]))], 512), [
                [_vShow, __props.bookTutorial.isVisible()]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})